module.exports = __webpack_public_path__ + "img/shutter-delete.8f1909f0.svg";